import Link from "next/link";
import styles from "./Avatar.module.css";

interface AvatarProps {
  src?: string | null;
  size?: number;
  alt?: string;
  href?: string;
  theme?: "dark" | "light";
}

/** User avatar; falls back to the RUBYN silhouette glyph (ported from old UI). */
export function Avatar({ src, size = 36, alt = "Account", href, theme = "dark" }: AvatarProps) {
  const cls = [styles.avatar, styles[`t-${theme}`]].join(" ");
  const style = { width: size, height: size };

  const content = src ? (
    // eslint-disable-next-line @next/next/no-img-element -- avatar may be a remote, unoptimized URL
    <img src={src} alt={alt} width={size} height={size} draggable={false} className={styles.img} />
  ) : (
    <svg
      width={size * 0.6}
      height={size * 0.6}
      viewBox="0 0 22 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M21.947 23.0341C21.203 20.7144 19.7418 18.6909 17.774 17.2554C15.8059 15.8198 13.4329 15.0463 10.9969 15.0463C8.56097 15.0463 6.18794 15.8198 4.21996 17.2554C2.252 18.6909 0.790738 20.7144 0.046875 23.0341L0.0515282 24H21.9517L21.947 23.0341Z" />
      <path d="M10.9968 11.517C14.1772 11.517 16.7553 8.93887 16.7553 5.75852C16.7553 2.57817 14.1772 0 10.9968 0C7.81645 0 5.23828 2.57817 5.23828 5.75852C5.23828 8.93887 7.81645 11.517 10.9968 11.517Z" />
    </svg>
  );

  if (href) {
    return (
      <Link href={href} className={cls} style={style} aria-label={alt}>
        {content}
      </Link>
    );
  }
  return (
    <span className={cls} style={style} aria-label={alt}>
      {content}
    </span>
  );
}
